import { AxiosError } from 'axios'
import { isServerErrorStatus, TECHNICAL_TEAM_ERROR_MESSAGE } from '@constants/userFacingErrors'

export interface ApiError {
  message: string
  status?: number
  data?: any
}

function backendErrorMessage(data: unknown): string | undefined {
  if (!data || typeof data !== 'object') return undefined
  const record = data as Record<string, unknown>
  if (typeof record.message === 'string' && record.message.trim()) {
    return record.message.trim()
  }
  if (typeof record.error === 'string' && record.error.trim()) {
    return record.error.trim()
  }
  return undefined
}

export function handleApiError(error: unknown): ApiError {
  if (error instanceof AxiosError) {
    const status = error.response?.status

    if (isServerErrorStatus(status)) {
      return {
        message: TECHNICAL_TEAM_ERROR_MESSAGE,
        status,
        data: error.response?.data,
      }
    }

    const message = backendErrorMessage(error.response?.data)
    if (message) {
      return {
        message,
        status,
        data: error.response?.data,
      }
    }

    if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
      return {
        message: 'Erro de conexão. Verifique se o servidor está a responder e tente novamente.',
        status: 0,
      }
    }

    return {
      message: error.message || 'Não foi possível concluir o pedido. Tente novamente.',
      status,
      data: error.response?.data,
    }
  }

  return {
    message: error instanceof Error ? error.message : 'Não foi possível concluir o pedido. Tente novamente.',
  }
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const apiError = handleApiError(error)
  return apiError.message || fallback
}
